import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import RegisterButton from '../../components/atoms/RegisterButton';
import { getAccounts } from '../../actions/Accounts';
import { PostStatisticalReportDownload } from '../../actions/Reports';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  paddingLeft8: {
    width: '146px'
  },
  formCheckbox: {
    display: 'inline-block'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getAccounts, PostStatisticalReportDownload },
        dispatch
      )
    })
  ),
  withState('InputFrom', 'setInputFrom', null),
  withState('InputType', 'setType', null),
  withState('InputTo', 'setInputTo', null),
  withState('InputCheckbox', 'setInputCheckbox', false),
  withState('error', 'setError', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    error,
    setError,
    InputFrom,
    setInputFrom,
    InputType,
    setType,
    InputTo,
    setInputTo,
    classes,
    // InputCheckbox1,
    InputCheckbox,
    // setInputCheckbox1,
    disableStatus,
    setInputCheckbox
  }) => {
    const generateCodeAction = async (
      dataReportType,
      dataReSync,
      dataFrom,
      dataTo
    ) => {
      const params = {
        reportType: dataReportType,
        reSync: dataReSync,
        from: dataFrom,
        to: dataTo
      };
      actions.PostStatisticalReportDownload(params).then(data => {
        if (data.type === 'POST_STATISTICAL_REPORT_DOWNLOAD_SUCCESS') {
          alert('Download Success');
          window.open(data.payload.downloadUrl, '_blank');
        } else {
          alert('Download Fail!');
        }
      });
    };
    const DowloadData = () => {
      if (!InputType || !InputTo || !InputFrom || !InputCheckbox) {
        setError('input not empty');
      } else if (moment(InputTo).isAfter(moment(InputFrom))) {
        setError('request from < to');
      } else if (
        InputType === 'MONTH' &&
        moment().format('MM') <= moment(InputTo).format('MM')
      ) {
        setError('Report type = MONTH and from is the current month or less');
      } else if (
        InputType === 'RANGE' &&
        moment().isAfter(moment(InputTo)) &&
        moment().isAfter(moment(InputFrom))
      ) {
        setError('Report type = RANGE and from , to < now');
      } else {
        generateCodeAction(InputType, InputCheckbox, InputTo, InputFrom);
        setError('');
      }
    };

    return (
      <div className="box-create">
        <h2>download statistical report</h2>
        <br />
        <br />
        <p>Input</p>
        <p>Report type</p>
        <Select
          labelId="rowsPerPageLabel"
          id="rowsPerPage"
          value={InputType}
          className={classes.paddingLeft8}
          onChange={e => {
            setType(e.target.value);
          }}
          fontSize={14}
        >
          <MenuItem value="RANGE">RANGE</MenuItem>
          <MenuItem value="MONTH">MONTH</MenuItem>
        </Select>
        <p>Resync</p>
        <RadioGroup
          value={InputCheckbox}
          className={classes.formCheckbox}
          onChange={e => {
            setInputCheckbox(e.target.value);
          }}
        >
          <FormControlLabel
            value="true"
            control={<Radio color="primary" disabled={disableStatus} />}
            label="true"
          />

          <FormControlLabel
            value="false"
            control={<Radio color="primary" disabled={disableStatus} />}
            label="false"
          />
        </RadioGroup>
        <p>From</p>
        <input
          className="group"
          type="date"
          name="from"
          onChange={e => {
            setInputTo(e.target.value);
          }}
        />
        <p>To</p>
        <input
          className="group"
          type="date"
          name="to"
          onChange={e => {
            setInputFrom(e.target.value);
          }}
        />
        {error && <p>{error}</p>}
        <br />
        <RegisterButton onClickAction={DowloadData} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
